<div class="bz-control bz-time-picker">
  <div class="bz-time-picker__section">
    <input [disabled]="!enableditem" class="bz-input bz-time-picker__section__input" type="text" [(ngModel)]="recurrence.frequency" (blur)="valueNull()" [maxlength]="recurrence.limitLength" InputNumberOnly>
    <div class="bz-time-picker__arrows" *ngIf="enableditem">
      <svg class="bz-time-picker__arrows__item" (click)="maxFrequency()">
        <use xlink:href="#arrow-up" />
      </svg>
      <svg class="bz-time-picker__arrows__item" (click)="minFrequency()">
        <use xlink:href="#arrow-down" />
      </svg>
    </div>
  </div>
</div>


